import { Facet } from "@linkfluence/models/facet";
import { Metric } from "@linkfluence/models/metric";
import { SearchRepository } from "@radarly/core/search/repositories/SearchRepository";
import { getLabelFromReviewValue } from "@radarly/models/facets";
import { getProductFromFacet } from "@radarly/models/review";
import { SearchFragmentTerm } from "@radarly/models/search";
import { ProductRepo } from "./ProductRepo";

interface Dependencies {
  searchRepo: SearchRepository;
}

export class ConnectedProductRepo implements ProductRepo {
  private searchRepo: SearchRepository;
  constructor(dependencies: Dependencies) {
    this.searchRepo = dependencies.searchRepo;
  }

  public getProducts(project: number, facet: Facet) {
    const product = getProductFromFacet(facet);
    return this.searchRepo
      .searchFragmentData(
        project,
        {
          query: {
            and: [],
          },
          aggs: {
            [product]: {
              metrics: [Metric.Doc],
              sort: {
                on: Metric.Doc,
                order: "desc",
              },
              topHit: { size: 1 },
            },
          },
        },
        true
      )
      .then((data: SearchFragmentTerm["data"]) => {
        return data.aggs[facet].values.map((item) => ({
          id: item.key,
          label: getLabelFromReviewValue(item, facet),
          status: "none",
        }));
      })
      .catch((err) => {
        throw new Error("super " + err);
      });
  }
}
